import { Observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowRightIcon } from '../../../../../../assets/icons/common/common-icons';
import { PrimaryButtonWithIcon } from '../../../../../../common/components/buttons/NewButtons.styles';
import { useStore } from '../../../../../app/data/root.store';
import { AssetVipSyncingTabWrapper, ConsentReminder, ItemLogoWrapper, LogoPlaceHolder, PromptWrapper, VipBadgeWrapper } from './AssetVipSyncingTab.styles';
import {VipSyncStatusCard} from './VipSyncStatusCard';
import { navigateToUrl } from '../../../../../../common/utils/navigation.utils';

export const AssetVipSyncingTab = ({ id, item, onClose }) => {
  const { userStore, createItemStore, itemStore } = useStore();
  const history = useHistory();
  useEffect(() => {
    if (!item?.settings?.promptDismissed?.vipSyncAwareness) {
      itemStore.dismissVipSyncAwareness(id);
    }
    // return () => {}
  }, [id, item, itemStore])
  

  const handleVipSyncClick = () => {
    if (userStore.isActionBlockedByRole('vipSyncFromItemPageTab')) {
      userStore.setShowLimitedSharedAccess(true);
    } else if (userStore.isVipSyncInstitutionLimited) {
      createItemStore.setShowAddVipSyncLimitModal(true);
    } else {
      createItemStore.setIsFromVipVipSyncingTab(true);
      createItemStore.setSelectedVipSyncInstitution(item.institutionsList);
      createItemStore.setVipSyncStep();
      createItemStore.setShowModal(true);
    }
  }

  const handleCheckStatusClick = () => {
    const message = `${itemStore.item?.institutionsList?.name} is VIP synced, but I’m missing an asset named ${itemStore.item?.title}. Can you help?`
    window.Intercom && window.Intercom('showNewMessage', message);
  }

  const handleDismissSyncTabClick = () => {
    itemStore.dismissVipSyncAwarenessTab(id);
    const searchParams = new URLSearchParams(window.location.search);
    navigateToUrl(history, `events${searchParams.size > 0 ? `?${searchParams.toString()}` : ``}`, false)
  }
  // const handleCloseButtonClick = () => {
  //   itemStore.dismissVipSyncAwareness(id);
  //   onClose?.();
  // }

  return (
    <Observer>{() => (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <AssetVipSyncingTabWrapper>
        <ItemLogoWrapper>
          {itemStore.item?.institutionsList?.logoBase64 ?<img alt={itemStore.item?.institutionsList?.name} src={'data:image/png;base64,' + itemStore.item?.institutionsList?.logoBase64} /> :
          itemStore.item?.institutionsList?.logoURL ? <img alt={itemStore.item?.institutionsList?.name} src={itemStore.item?.institutionsList?.logoURL} /> :
            itemStore.item?.institutionsList?.logoUrl ? <img alt={itemStore.item?.institutionsList?.name} src={itemStore.item?.institutionsList?.logoUrl} /> : 
          <LogoPlaceHolder ><VipPlaceholderIcon /></LogoPlaceHolder>
    } 
      <VipBadgeWrapper>
        <VipBadge />
      </VipBadgeWrapper>
          </ItemLogoWrapper>
          { !itemStore.relatedVipInstitution && <>
            <PromptWrapper>{!userStore.isVipSyncInstitutionLimited ? 'VIP Syncing is available for this portal' : 'Keep All Your Portals in Sync'} </PromptWrapper>
            {!userStore.isVipSyncInstitutionLimited ? <>
            <ConsentReminder>
              Sync {itemStore.item?.institutionsList?.name} to keep your data effortlessly up to date.
            </ConsentReminder>
            <PrimaryButtonWithIcon onClick={handleVipSyncClick} style={{ width: 'fit-content', marginTop: '16px' , paddingRight: '12px' }} iconStrokeColor={'#fff'}>
              Sync now <ArrowRightIcon />
            </PrimaryButtonWithIcon>
            </> : <>
            <ConsentReminder style={{color: '#1A1B1D'}}>
            You’ve reached your limit of <span style={{ fontWeight: '700' }}>{userStore.userLimitations.financialInstitutionSync.vipSyncedInstitutions} VIP Synced portals.</span>
            </ConsentReminder>
            <ConsentReminder style={{color: '#1A1B1D'}}>
              Upgrade to sync {itemStore.item?.institutionsList?.name} and keep your financial data effortlessly updated.
            </ConsentReminder>
            <PrimaryButtonWithIcon onClick={handleVipSyncClick} style={{ width: 'fit-content', marginTop: '16px' }} iconStrokeColor={'#fff'}>
            <VipSyncSvg />Upgrade & Sync Now
            </PrimaryButtonWithIcon>
            </>}
          </> }
        
              {itemStore.relatedVipInstitution && itemStore.relatedVipInstitution.status === 'connected' && <>
                <PromptWrapper>This portal is already VIP Synced.</PromptWrapper>
                <ConsentReminder style={{color: '#1A1B1D'}}>Need this asset synced? Let us know, and we’ll check its status.</ConsentReminder>
                <PrimaryButtonWithIcon onClick={handleCheckStatusClick} style={{ width: 'fit-content', marginTop: '16px' , paddingRight: '12px' }} iconStrokeColor={'#fff'}>
                Check status <ArrowRightIcon />
                </PrimaryButtonWithIcon>
                <ConsentReminder style={{color: '#585D66' , cursor: 'pointer'}} onClick={handleDismissSyncTabClick}>Dismiss</ConsentReminder>
              </>}

              {itemStore.relatedVipInstitution && itemStore.relatedVipInstitution.status === 'pending' && <>
                <PromptWrapper>VIP Syncing request in progress...</PromptWrapper>
                <VipSyncStatusCard institutionName={itemStore.item?.institutionsList?.name} status={'pending'} is3rdParty={itemStore.item?.institutionsList?.vipAccessRequirement !== 'manual'} maxWidth={'320px'} showAsCard={true} />
              </>}

          {/* <ConsentReminder>
            This requires Vyzer to have <span style={{ fontWeight: '700' }}>read-only access</span> to your account.<br />
            The initial authorization may take some time, but it will fully serve your needs.
            {userStore.isVipSyncInstitutionLimited && <span style={{ fontWeight: '700' }}><br/>You have reached the limit of institutions for VIP Syncing Service</span>}
          </ConsentReminder>
          <PrimaryButtonWithIcon noStroke onClick={handleVipSyncClick} style={{ width: 'fit-content', marginTop: '16px' }}>
            <VipSyncSvg />VIP Syncing Service
            {userStore.isActionBlockedByRole('vipSyncFromItemPageTab') && <ActionLockedIconWithTooltip iconColor={'#DDE3EB'} isRoleBlocked={true} />}
          </PrimaryButtonWithIcon> */}

          {/* <div id="ds-clickwrap" ></div>
          <button onClick={handleClickwrapButtonClick}>Clickwrap Button</button> */}

        </AssetVipSyncingTabWrapper>
      </div>
    )}</Observer>)
}

// const CloseButtonSvg = () => {
//   return (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <line x1="6.28033" y1="5.83295" x2="18.3011" y2="17.8538" stroke="#9097A3" strokeWidth="1.5" />
//       <line x1="5.92695" y1="17.8544" x2="17.9478" y2="5.83362" stroke="#9097A3" strokeWidth="1.5" />
//     </svg>
//   )
// }

export const VipSyncSvg = () => {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2.19507L3.36578 5.48769L6.14621 0V9.21931H0V2.19507Z" fill="white" />
      <path d="M6.14624 0L8.92667 5.48769L12.2924 2.19507V9.21931H6.14624V0Z" fill="white" />
      <line x1="0.614746" y1="11.2625" x2="11.6779" y2="11.2625" stroke="white" strokeWidth="1.47509" />
    </svg>
  )
}

const VipBadge = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <rect x="0.5" y="0.5" width="18" height="18" rx="9" fill="#DEB482"/>
    <rect x="0.5" y="0.5" width="18" height="18" rx="9" stroke="white"/>
    <path d="M5.5 6.46335L7.7438 8.65837L9.59738 5V11.1461H5.5V6.46335Z" fill="white"/>
    <path d="M9.59741 5L11.451 8.65837L13.6948 6.46335V11.1461H9.59741V5Z" fill="white"/>
    <line x1="5.90979" y1="12.5083" x2="13.2851" y2="12.5083" stroke="white" strokeWidth="0.98337"/>
  </svg>
  )
}

const VipPlaceholderIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.32099 11.2227H13.679L14.6667 12.7041H1.33334L2.32099 11.2227Z" fill="#9097A3"/>
      <path d="M1.58025 5.29695L7.99981 2.33398L14.4198 5.29695H1.58025Z" fill="#9097A3"/>
      <rect x="8.74069" y="6.28516" width="1.48148" height="3.95062" fill="#9097A3"/>
      <rect x="2.81489" y="6.28516" width="1.48148" height="3.95062" fill="#9097A3"/>
      <rect x="11.7038" y="6.28516" width="1.48148" height="3.95062" fill="#9097A3"/>
      <rect x="5.77802" y="6.28516" width="1.48148" height="3.95062" fill="#9097A3"/>
    </svg>    
  )
}